import WebLayout from './CommentsNumberField.web';
import MobileLayout from './CommentsNumberField.mobile';
import { isReactNative } from 'ui-builder';

export * from './types';

export default isReactNative() ? MobileLayout : WebLayout;
